/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * DivisionArrayElement.tsx -
 */

import { StyleSheet, View } from 'react-native';

interface DivisionArrayElementProps {
  width: number,
  height: number,
  color: 'red' | 'yellow'
}

const DivisionArrayElement = ({width, height, color}: DivisionArrayElementProps) => {

  const squareStyle = {width:width, height:height };
  const circleStyle = {backgroundColor: color};

  return (
    <View style={[styles.square, squareStyle]}>
      <View style={[styles.circle, circleStyle]}/>
    </View>
  );
};

export default DivisionArrayElement;

const styles = StyleSheet.create({
  square: {
    color: '#20232a',
    textAlign: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 30,
    fontWeight: 'bold',
  },

  circle: {
    aspectRatio: 1,
    borderRadius: 200,
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
    width: '95%',
    height: '95%',
  },

});